import { GenericSingleDateFilter } from '@app/core/list-view/base-filters/GenericSingleDateFilter';
import {
  parseAsSingleDateFilter,
  SingleDateFilterValue,
} from '@app/core/list-view/helpers/parse-as-single-date-filter';
import { singleDateFilterValueToIsoRange } from '@app/core/list-view/helpers/single-date-filter-value-to-range';
import { createFilter } from '@app/core/list-view/types';

/**
 * Maps a single-date filter value to BFF `from` / `to` ISO query params for YouTube broadcasts.
 */
export function youtubeBroadcastsDateToApiParams(
  val: SingleDateFilterValue | null | undefined,
  timezone?: string,
): Record<string, string> | null {
  const { from, to } = singleDateFilterValueToIsoRange(val ?? null, timezone ?? 'UTC');

  if (!from || !to) {
    return null;
  }

  return { from, to };
}

export const YOUTUBE_BROADCASTS_FILTERS_CONFIG = [
  createFilter({
    name: 'targetDate',
    label: false,
    parser: parseAsSingleDateFilter.withDefault({ presetId: 'today' }),
    isPermanent: true,
    component: GenericSingleDateFilter,
    componentProps: {},
    raw: (val, context) =>
      youtubeBroadcastsDateToApiParams(val, context?.timezone as string | undefined),
  }),
];
